import { __assign, __extends } from "tslib";
import React from 'react';
import BaseViewer from './Base';
import omit from 'lodash/omit';
import mergeTheme from '../Themes/mergeTheme';
import baseTheme from '../Themes/Viewer/commission.scss';
var CommissionViewer = /** @class */ (function (_super) {
    __extends(CommissionViewer, _super);
    function CommissionViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.theme = mergeTheme(baseTheme, _this.props.theme);
        return _this;
    }
    CommissionViewer.prototype.render = function () {
        var restProps = omit(this.props, ['theme']);
        return (React.createElement("div", { className: 'da-editor-commission' },
            React.createElement(BaseViewer, __assign({ theme: this.theme }, restProps, { fixedParagraph: false }))));
    };
    return CommissionViewer;
}(React.Component));
export default CommissionViewer;
//# sourceMappingURL=Commission.js.map